import { useDropdown } from "./Root"
import StyledContent from "./styles/ContentStyles"

interface ContentProps {
  children: React.ReactNode | React.ReactNode[]
}

export const Content = ({ children, ...rest }: ContentProps) => {
  const { state } = useDropdown(`Content`)
  return state.open ? <StyledContent {...rest}>{children}</StyledContent> : null
}
